import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/global-scripts')({
  beforeLoad: () => getTitleContextSlice('Global Scripts'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
